export const loginByPhoneNo=1
export const loginByGoogle =2
export const loginByFaceBook =3
export const loginByEmail =4